export default [
  {
    name: 'project_duration_statistic',
    component_path: 'modules/templates/blocks/project/ProjectStatistic',
    settings: {
      statistic: 'duration',
      text: 'duration'
    }
  }
]